import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

const TrainingenPage = () => {
  const trainingsvoordelen = [
    {
      icon: 'ri-lightbulb-line',
      titel: 'Kwaliteiten herkennen',
      beschrijving: 'Leerlingen leren hun unieke talenten en sterke punten te ontdekken en waarderen.'
    },
    {
      icon: 'ri-refresh-line',
      titel: 'Negatieve gedachten vervangen',
      beschrijving: 'We helpen bij het omzetten van negatieve gedachtenpatronen naar helpende, realistische gedachten.'
    },
    {
      icon: 'ri-trophy-line',
      titel: 'Succeservaringen verankeren',
      beschrijving: 'Positieve ervaringen worden bewust opgeroepen en versterkt voor blijvend zelfvertrouwen.'
    },
    {
      icon: 'ri-chat-smile-line',
      titel: 'Positieve zelfspraak',
      beschrijving: 'Leerlingen ontwikkelen een ondersteunende innerlijke dialoog die hen helpt groeien.'
    }
  ];

  const trainingsonderdelen = [
    {
      week: 'Week 1-2',
      titel: 'Zelfbeeld Verkennen',
      beschrijving: 'We beginnen met het in kaart brengen van het huidige zelfbeeld en het identificeren van sterke punten.',
      activiteiten: ['Zelfbeeld-assessment', 'Sterke punten ontdekken', 'Doelen stellen']
    },
    {
      week: 'Week 3-4',
      titel: 'Gedachten Herkennen',
      beschrijving: 'Leerlingen leren negatieve gedachtenpatronen te herkennen en te begrijpen waar deze vandaan komen.',
      activiteiten: ['Gedachten-dagboek', 'Patronen herkennen', 'Triggers identificeren']
    },
    {
      week: 'Week 5-6',
      titel: 'Nieuwe Gedachten Ontwikkelen',
      beschrijving: 'We oefenen met het vervangen van negatieve gedachten door helpende, realistische alternatieven.',
      activiteiten: ['Gedachten omzetten', 'Realiteitscheck', 'Positieve affirmaties']
    },
    {
      week: 'Week 7-8',
      titel: 'Succeservaringen Versterken',
      beschrijving: 'Focus op het bewust oproepen en verankeren van positieve ervaringen en prestaties.',
      activiteiten: ['Succesverhalen delen', 'Prestaties vieren', 'Geheugenversterking']
    },
    {
      week: 'Week 9-10',
      titel: 'Praktijk en Toepassing',
      beschrijving: 'Het geleerde wordt toegepast in praktijksituaties en dagelijkse uitdagingen.',
      activiteiten: ['Rollenspel', 'Echte situaties', 'Feedback en reflectie']
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Sectie */}
      <section
        className="relative py-32 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/be7856a28438a8e3d491040b8792eb9f.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-green-900/85 via-green-900/60 to-transparent"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
              Onze Trainingen
            </h1>
            <p className="text-xl md:text-2xl text-gray-100 leading-relaxed">
              Bewezen trainingsprogramma's die jongeren helpen hun zelfvertrouwen 
              te herwinnen en hun potentieel te ontdekken.
            </p>
          </div>
        </div>
      </section>

      {/* Sterk in je Zelf - Hoofdtraining */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="mb-6">
                <span className="inline-block bg-orange-100 text-orange-500 px-3 py-1 rounded-full text-sm font-semibold uppercase tracking-wider">
                  Hoofdtraining
                </span>
              </div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                Sterk in je Zelf
              </h2>
              <p className="text-lg text-gray-600 mb-6">
                Een gezond zelfbeeld vormt de basis voor leren, motivatie en sociaal functioneren. 
                Deze training helpt jongeren hun zelfvertrouwen te herwinnen en hun potentieel te ontdekken.
              </p>
              <div className="space-y-4 mb-8">
                <div className="flex items-center space-x-3">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-group-line text-orange-500 text-lg"></i>
                  </div>
                  <span className="text-gray-700">
                    <strong>Doelgroep:</strong> Bovenbouw basisschool en onderbouw voortgezet onderwijs
                  </span>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-time-line text-orange-500 text-lg"></i>
                  </div>
                  <span className="text-gray-700">
                    <strong>Duur:</strong> 10 weken, 1 sessie per week van 90 minuten
                  </span>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-team-line text-orange-500 text-lg"></i>
                  </div>
                  <span className="text-gray-700">
                    <strong>Groepsgrootte:</strong> Maximaal 8 deelnemers voor persoonlijke aandacht
                  </span>
                </div>
              </div>
              <Button href="/contact?onderwerp=training" variant="primary" size="lg">
                Aanmelden voor Training
              </Button>
            </div>
            <div>
              <img
                src="https://readdy.ai/api/search-image?query=Young%20students%20sitting%20in%20a%20circle%20during%20a%20confidence%20building%20training%20session%2C%20supportive%20group%20environment%2C%20bright%20room%20with%20plants%20and%20motivational%20posters%2C%20diverse%20teenagers%20engaged%20in%20positive%20interaction&width=600&height=500&seq=herstart-sterk-in-jezelf&orientation=portrait"
                alt="Sterk in je Zelf training"
                className="rounded-lg shadow-lg object-cover w-full h-96"
              />
            </div>
          </div>
        </div>
      </section>

      {/* COMET Methode */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Gebaseerd op COMET Methode
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Onze training is gebaseerd op de principes van Competitive Memory Training (COMET), 
              vertaald naar een praktische, kindvriendelijke aanpak die bewezen effectief is.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {trainingsvoordelen.map((voordeel, index) => (
              <div key={index} className="bg-white rounded-lg p-6 shadow-sm text-center">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${voordeel.icon} text-orange-500 text-2xl`}></i>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-3">
                  {voordeel.titel}
                </h3>
                <p className="text-gray-600">
                  {voordeel.beschrijving}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Trainingsopbouw */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Trainingsopbouw
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              De training is opgebouwd uit een gestructureerde reeks weken, elk met een duidelijk thema en concrete activiteiten.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {trainingsonderdelen.map((onderdeel, idx) => (
              <div key={idx} className="border rounded-lg p-6 shadow-sm">
                <h3 className="text-xl font-semibold text-gray-800 mb-2">
                  {onderdeel.week}: {onderdeel.titel}
                </h3>
                <p className="text-gray-600 mb-4">{onderdeel.beschrijving}</p>
                <ul className="list-disc list-inside">
                  {onderdeel.activiteiten.map((act, i) => (
                    <li key={i} className="text-gray-700">{act}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <Button href="/contact?onderwerp=samenwerking" variant="secondary" size="lg">
              Meer informatie over de training
            </Button>
          </div>
        </div>
      </section>

      {/* Groepstraining op Locatie */}
      <section className="pt-16 pb-12 bg-green-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">

            {/* Visueel blok */}
            <div className="order-2 lg:order-1 w-full h-auto rounded-2xl bg-green-700 overflow-hidden">
              {/* Header */}
              <div className="px-6 pt-6 pb-4 border-b border-green-600">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-green-500 rounded-lg flex items-center justify-center">
                    <i className="ri-map-pin-line text-white text-lg"></i>
                  </div>
                  <div>
                    <p className="text-green-200 text-xs uppercase tracking-widest">HerStart</p>
                    <p className="text-white font-bold text-sm">Training op locatie</p>
                  </div>
                </div>
              </div>

              {/* Stats rij */}
              <div className="grid grid-cols-3 divide-x divide-green-600 border-b border-green-600">
                <div className="px-4 py-4 text-center">
                  <p className="text-3xl font-bold text-white">6–20</p>
                  <p className="text-green-300 text-xs mt-1">leerlingen</p>
                </div>
                <div className="px-4 py-4 text-center">
                  <p className="text-3xl font-bold text-orange-300">10</p>
                  <p className="text-green-300 text-xs mt-1">weken</p>
                </div>
                <div className="px-4 py-4 text-center">
                  <p className="text-3xl font-bold text-white">85%</p>
                  <p className="text-green-300 text-xs mt-1">slaagkans</p>
                </div>
              </div>

              {/* Programma tijdlijn */}
              <div className="px-6 py-5 space-y-3">
                <p className="text-green-300 text-xs uppercase tracking-widest mb-4">Programmaopbouw</p>
                {[
                  { label: 'Zelfbeeld verkennen', week: 'Wk 1–2', pct: 'w-1/5' },
                  { label: 'Gedachten herkennen', week: 'Wk 3–4', pct: 'w-2/5' },
                  { label: 'Nieuwe gedachten', week: 'Wk 5–6', pct: 'w-3/5' },
                  { label: 'Succeservaringen', week: 'Wk 7–8', pct: 'w-4/5' },
                  { label: 'Praktijk & toepassing', week: 'Wk 9–10', pct: 'w-full' },
                ].map((item, i) => (
                  <div key={i}>
                    <div className="flex justify-between items-center mb-1">
                      <span className="text-white text-xs">{item.label}</span>
                      <span className="text-green-400 text-xs">{item.week}</span>
                    </div>
                    <div className="h-1.5 bg-green-900 rounded-full">
                      <div className={`h-1.5 bg-orange-400 rounded-full ${item.pct}`}></div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Footer */}
              <div className="px-6 py-4 bg-green-800 flex items-center gap-2">
                <i className="ri-checkbox-circle-line text-green-400"></i>
                <span className="text-green-200 text-xs">Inclusief voortgangsrapportage per deelnemer</span>
              </div>
            </div>

            {/* Inhoud */}
            <div className="order-1 lg:order-2">
              <span className="inline-block bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm font-semibold uppercase tracking-wider mb-4">
                Voor scholen &amp; gemeenten
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Groepstraining op locatie
              </h2>
              <p className="text-lg text-gray-600 mb-8">
                Wij komen naar uw school of instelling toe. De training wordt volledig op maat 
                ingericht voor uw groep — van een enkele klas tot een bredere groep kwetsbare jongeren.
              </p>

              {/* Kenmerken */}
              <div className="space-y-4 mb-8">
                <div className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Wij komen naar u toe</h4>
                    <p className="text-sm text-gray-600">Geen vervoer of externe locatie nodig — training vindt plaats in uw eigen omgeving.</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-settings-3-line text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Volledig maatwerk</h4>
                    <p className="text-sm text-gray-600">Het programma wordt afgestemd op de doelgroep, het niveau en de specifieke behoeften van uw leerlingen.</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-group-line text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Groepen van 6 tot 20 leerlingen</h4>
                    <p className="text-sm text-gray-600">Klein genoeg voor persoonlijke aandacht, groot genoeg voor groepsdynamiek en herkenning.</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-file-list-3-line text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Voortgangsrapportage</h4>
                    <p className="text-sm text-gray-600">Na afloop ontvangt u een overzicht van de resultaten en aanbevelingen per deelnemer.</p>
                  </div>
                </div>
              </div>

              {/* Hoe werkt het */}
              <div className="bg-white rounded-xl p-5 mb-8 border border-green-100">
                <h3 className="font-semibold text-gray-900 mb-4">Hoe werkt het?</h3>
                <div className="space-y-3">
                  <div className="flex items-center gap-3">
                    <div className="w-7 h-7 bg-green-600 text-white rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">1</div>
                    <span className="text-sm text-gray-700">Vrijblijvend kennismakingsgesprek over uw situatie en wensen</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-7 h-7 bg-green-600 text-white rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">2</div>
                    <span className="text-sm text-gray-700">Wij stellen een passend trainingsplan op voor uw groep</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-7 h-7 bg-green-600 text-white rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0">3</div>
                    <span className="text-sm text-gray-700">Training start op locatie, inclusief begeleiding en rapportage</span>
                  </div>
                </div>
              </div>

              <Button href="/contact?onderwerp=groepstraining" variant="secondary" size="lg">
                Groepstraining aanvragen
              </Button>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TrainingenPage;
